import script from "./editTenant.vue?vue&type=script&setup=true&lang=js"
export * from "./editTenant.vue?vue&type=script&setup=true&lang=js"

import "./editTenant.vue?vue&type=style&index=0&id=b015047c&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b015047c"]])

export default __exports__